import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app';
import { AppProviders } from '@/app/providers';

import './app/styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
